<template>
    <form @submit.prevent="store()" v-show="show">
        <div class="modal_content p-15 m-0">
            <div class="row">
                <div class="col-sm-9 col-md-9 m_sm_bottom_15" :class="{'has-error': errors['package_id']}">
                    <label class="control-label">{{ $t('package') }}</label>
                    <pml-select v-model="chosen" :options="packages"></pml-select>
                    <span class="error" v-if="errors['package_id']">{{ $t(errors['package_id'][0], $t('package')) }}</span>
                </div>
                <div class="col-md-3 t_right m-t-23">
                    <span class="btn btn-white" @click.prevent="cancel()">{{ $t('cancel') }}</span>
                    <button type="submit" class="btn btn-default" v-pml-block="isSaving">{{ $t('save') }}</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { addPackage } from 'services/quotation-products'
    import { mapGetters } from 'vuex'
    import { find } from 'lodash'

    export default {
        name: 'QuotationProductsPackage',
        props: [ 'show' ],
        computed: {
            ...mapGetters({
                'deal': 'getDealInfo',
                'quotations': 'getDealQuotations',
                'packages': 'getActivePackages'
            }),
            quotation () {
                return find(this.quotations, { id: parseInt(this.$route.params.quotation) }) || {}
            }
        },
        data () {
            return {
                isSaving: false,
                chosen: '',
                errors: []
            }
        },
        methods: {
            cancel () {
                this.chosen = ''
                this.errors = []
                this.$emit('close')
            },
            store () {
                if (this.chosen === '') {
                    this.errors = { package_id: [ 'required_field' ] }
                    return
                }

                this.isSaving = true

                addPackage(this.deal.id, this.quotation.id, this.chosen)
                    .then(() => {
                        Notify.success(trans('_notifications.success'))
                        this.cancel()
                    })
                    .catch(() => { Notify.error(trans('_notifications.error')) })
                    .then(() => { this.isSaving = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/quotations/edit/products/AddPackage.vue